import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";

// Define a type for the slice state
export interface AttributesListTableStateState {
    TableState: string;
}

// Define the initial state using that type
const initialState: AttributesListTableStateState = {
    TableState: JSON.stringify({
        sorting: {
            sortModel: [{ field: "name", sort: "asc" }],
        },
        filter: {
            filterModel: {
                items: [
                    {
                        id: 1,
                        columnField: "status",
                        operatorValue: "startsWith",
                        value: "active",
                    },
                ],
            },
        },
    }),
};

export const AttributesListTableStateSlice = createSlice({
    name: "AttributesListTableState",
    initialState,
    reducers: {
        // Use the PayloadAction type to declare the contents of `action.payload`
        updateAttributesGridState: (state, action: PayloadAction<string | null>) => {
            state.TableState = action?.payload ?? initialState.TableState;
        },
    },
});

export const { updateAttributesGridState } = AttributesListTableStateSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const AttributesListTableState = (state: RootState) => state;
export default AttributesListTableStateSlice.reducer;
